import { useLoaderData } from 'react-router';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { DateCalendar } from "@mui/x-date-pickers";

import AHDate from "_shared/dates/date";
import { useSession } from 'users/__session/session-context';
import CallToAction from '_shared/_views/calls-to-action/call-to-action';
import CtaBackground from '_shared/_views/assets/call-to-action-background.jpg'

const Main = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0)
  },
  padding: theme.spacing(2)
}));
const Layout = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));
const Greeting = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    margin: 'auto',
    marginTop: '1.5rem'
  },
  marginBottom: '1em',
  textAlign: 'center'
}));
const Calendar = styled(DateCalendar)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    margin: 'auto'
  },
  marginLeft: '2em'
}));

export default function Dashboard() {
  const partOfDay = useLoaderData();
  const session = useSession();

  return (
    <Main container direction="row">
      <Layout size={{ md: 7, xl: 6 }}>
        <CallToAction
          title='Explore the marketplace and find what you need quickly and easily'
          buttonText={'Go To Marketplace'}
          redirectUrl='/marketplace'
          backgroundImageUrl={CtaBackground}
        />
      </Layout>
      <Layout>
        <Greeting variant="h5">
          {`${partOfDay}, ${session.user?.name.firstName}`}
        </Greeting>
        <Calendar defaultValue={new AHDate().asMoment} value={new AHDate().asMoment} />
      </Layout>
    </Main>
  )
}
